<template>
  <v-app id="login">
    <v-main>
      <v-container fluid fill-height>
        <v-row align-center justify-center class="fill-height">
          <v-col
            xs12
            sm12
            md4
            class="d-none d-sm-flex"
            style="
              background-color: #eee;
              width: 100%;
              height: 100%;
              background-position: center;
              background-size: cover;
            "
            :style="{
              backgroundImage: 'url(' + require('@/assets/img/3878.jpg') + ')',
            }"
          >
          </v-col>
          <v-col xs12 sm12 md8 align-self="center">
            <el-card class="box-card" style="width: 500px; margin: 0 auto">
              <v-card-text>
                <div class="text-center">
                  <img
                    src="../assets/img/logo-full-text.png"
                    style="width: 45%"
                  />
                </div>
                <el-form ref="form">
                  <el-form-item>
                    <el-input
                      v-model="formLogin.email"
                      placeholder="อีเมลแอดเดรส"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      :type="passwordVisible"
                      v-model="formLogin.password"
                      placeholder="รหัสผ่าน"
                    >
                      <el-button
                        slot="append"
                        :icon="icon"
                        @click="togglePasswordVisible()"
                      ></el-button>
                    </el-input>
                  </el-form-item>
                </el-form>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  depressed
                  block
                  type="submit"
                  :disabled="!valid"
                  form="login-form"
                  color="primary"
                  @click="submitLogin"
                  >เข้าสู่ระบบ</v-btn
                >
              </v-card-actions>
            </el-card>
          </v-col>
        </v-row>
        <v-dialog v-model="isLoading" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Loading...
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
    <div class="my-2 text-center grey--text">
      Halalize Co., Ltd © 2019 - 2022
    </div>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    isLoading: false,
    valid: true,
    passwordVisible: "password",
    icon: "far fa-eye",
    formLogin: {
      email: "",
      password: "",
    },
  }),
  props: {},
  created() {
    this.isLoading = false;
  },
  methods: {
    togglePasswordVisible() {
      if (this.passwordVisible == "password") {
        this.passwordVisible = "text";
        this.icon = "far fa-eye-slash";
      } else {
        this.passwordVisible = "password";
        this.icon = "far fa-eye";
      }
    },
    submitLogin() {
      this.isLoading = true;

      this.formLogin.email.trim();
      this.formLogin.password.trim();

      this.$store
        .dispatch("Auth/login", this.formLogin)
        .then((res) => {
          this.$store.dispatch("Auth/setUser");
          this.isLoading = false;
          this.$router.push("/");
        })
        .catch((err) => {
          alert(err);
          this.isLoading = false;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
